// extracted by mini-css-extract-plugin
export default {"quiz_question_title":"question_quiz_question_title__PihU6","quiz_question_answer":"question_quiz_question_answer__Hl2cC"};